/**
 * Artikelbilder: je Artikelnummer ein Bild. Lieferanten weisen sich über den Einladungscode aus,
 * Administratoren über das Access-Token (Scope write:products).
 */
function authHeaders(options) {
  const headers = {}

  if (options.invitationCode != null) {
    headers['Invitation-Code'] = options.invitationCode
  } else if (options.accessToken != null) {
    headers['Authorization'] = `Bearer ${options.accessToken}`
  }

  return headers
}

async function throwIfNotOk(response) {
  if (response.ok) {
    return
  }

  let message = `HTTP ${response.status}`

  try {
    const body = await response.json()

    if (body.message) {
      message = body.message
    }
  } catch (e) {
    // kein JSON-Body
  }

  const error = new Error(message)
  error.status = response.status

  throw error
}

export default class ProductImageService {
  constructor(baseUrl) {
    this.baseUrl = baseUrl
  }

  /** Legt das Bild an oder ersetzt es. `blob` ist das bereits quadratisch zugeschnittene JPEG. */
  async upload(productId, blob, options) {
    const data = new FormData()
    data.append('file', blob, `${productId}.jpg`)

    const response = await fetch(`${this.baseUrl}/productImage/${encodeURIComponent(productId)}`, {
      body: data,
      headers: authHeaders(options),
      method: 'PUT'
    })

    await throwIfNotOk(response)

    return await response.json()
  }

  async delete(productId, options) {
    const response = await fetch(`${this.baseUrl}/productImage/${encodeURIComponent(productId)}`, {
      headers: authHeaders(options),
      method: 'DELETE'
    })

    await throwIfNotOk(response)

    return true
  }

  /** Einmalige Übernahme der statischen Altbilder (Administration). */
  async importLegacy(options) {
    const response = await fetch(`${this.baseUrl}/productImage/import-legacy`, {
      headers: authHeaders(options),
      method: 'POST'
    })

    await throwIfNotOk(response)

    return await response.json()
  }

  async getOrphaned(options) {
    const response = await fetch(`${this.baseUrl}/productImage/orphaned`, {
      headers: authHeaders(options)
    })

    await throwIfNotOk(response)

    return await response.json()
  }

  async deleteOrphaned(options) {
    const response = await fetch(`${this.baseUrl}/productImage/orphaned`, {
      headers: authHeaders(options),
      method: 'DELETE'
    })

    await throwIfNotOk(response)

    return await response.json()
  }
}
